import React, { PropTypes } from "react";
import ComponentRegistry from "../../Common/ComponentRegistry"

export default class PagingController extends React.Component {
    onChangePage(page) {
        const current = parseInt(this.props.pages.current, 10);

        let actualPage = page;
        if (page === "nextFive") {
            actualPage = current + 5;
        }
        if (page === "previousFive") {
            actualPage = current - 5;
        }
        if (page === "previous") {
            actualPage = current - 1;
        }
        if (page === "next") {
            actualPage = current + 1;
        }
        this.props.onChange(actualPage);
    }

    render() {
        if (typeof this.props.pages === "undefined") {
            return null;
        }
        const PagingView = ComponentRegistry.get(this.props.view);

        const pages = [];
        const current = parseInt(this.props.pages.current, 10);
        const total = parseInt(this.props.pages.total, 10);
        if (current > 1) {
            pages.push("previous");
        }
        let start = current - 2;
        start = start > 1 ? start : 1;
        let end = start + 4;
        end = end < total ? end : total;
        start = end - start < 5 ? end - 4 : start;
        start = start > 1 ? start : 1;
        if (current - 5 > 0) {
            pages.push("previousFive");
        }
        for (let i = start; i <= end; i += 1) {
            pages.push(i);
        }
        if (current + 5 <= total) {
            pages.push("nextFive");
        }
        if (current < total) {
            pages.push("next");
        }

        return (
          <PagingView {...this.props} pages={pages} current={current} onChangePage={page => this.onChangePage(page)} />
        );
    }
}
PagingController.propTypes = {
    view: PropTypes.string.isRequired,
    pages: PropTypes.shape({
        current: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        total: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    }),
    labels: PropTypes.shape({}).isRequired,
    onChange: PropTypes.func.isRequired,
};

PagingController.defaultProps = {
    view: "CommonPagingView",
};



// WEBPACK FOOTER //
// ./src-js/Fratello/Common/Controllers/PagingController.jsx